module.exports = {
      id: "glyph:download-usage",
      viewBox: "0 0 16 16",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#glyph:download-usage",
      toString: function () {
        return this.url;
      }
    }